import {
    type ReactNode,
    createContext
} from "react";

type PortalItem = {
    children: ReactNode;
    isModal?: boolean;
    name?: string;
    key: string;
};

let portals: PortalItem[] = [];

const listeners: Array<(portals: PortalItem[]) => void> = [];

const serverPortals: PortalItem[] = [];

export const POPOVER_PORTAL_NAME = "popover-system";

export const SNACK_BAR_PORTAL_NAME = "snack-bar-system";

export const PortalKeyContext = createContext<string | undefined>(undefined);

export const context = {
    update: (key: string, children: ReactNode, name?: string) => {
        portals = portals.map(p => p.key === key ? {
            ...p,
            children,
            name
        } : p);

        listeners.forEach(l => l(portals));
    },
    mount: (key: string, children: ReactNode, name?: string) => {
        portals = [
            ...portals,
            {
                children,
                name,
                key
            }
        ];

        listeners.forEach(l => l(portals));
    },
    subscribe: (listener: (portals: PortalItem[]) => void) => {
        listeners.push(listener);

        return () => {
            const listenerIndex = listeners.indexOf(listener);

            if(listenerIndex !== -1) {
                listeners.splice(listenerIndex, 1);
            }
        };
    },
    setModal: (key: string, isModal: boolean) => {
        const portal = portals.find(p => p.key === key);

        if(!portal || Boolean(portal.isModal) === isModal) {
            return;
        }

        portals = portals.map(p => p.key === key ? {
            ...p,
            isModal
        } : p);

        listeners.forEach(l => l(portals));
    },
    unmount: (key: string) => {
        portals = portals.filter(p => p.key !== key);

        listeners.forEach(l => l(portals));
    },
    getServerPortals: () => serverPortals,
    getPortals: () => portals
};
